import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { useScrollDirection } from '../../hooks/useScrollDirection.mjs';
import { useIsMobile } from '../../hooks/useIsMobile.mjs';

var WrapperBase = styled.div.withConfig({
  displayName: "WrapperBase",
  componentId: "sc-1xn4u67-0"
})(["", ";"], function (props) {
  return props.overrideStyle;
});
var Wrapper = styled(WrapperBase).withConfig({
  displayName: "Wrapper",
  componentId: "sc-1xn4u67-1"
})(["transition:transform 300ms;", ""], function (props) {
  return props.direction === "down" && css(["transform:translate(0,-50vh);height:0;"]);
});
function DisplayControllerAboutScrollDirection(_a) {
  var overrideStyle = _a.overrideStyle,
    disabled = _a.disabled,
    children = _a.children,
    onChangeDirection = _a.onChangeDirection,
    props = __rest(_a, ["overrideStyle", "disabled", "children", "onChangeDirection"]);
  var direction = useScrollDirection({
    initialDirection: "up"
  });
  var isMobile = useIsMobile();
  React.useLayoutEffect(function () {
    onChangeDirection === null || onChangeDirection === void 0 ? void 0 : onChangeDirection(direction);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [direction]);
  if (!isMobile || disabled) {
    if (overrideStyle) {
      return jsx(WrapperBase, Object.assign({
        overrideStyle: overrideStyle
      }, props, {
        children: children
      }));
    }
    return jsx(Fragment, {
      children: children
    });
  }
  return jsx(Wrapper, Object.assign({
    direction: direction,
    overrideStyle: overrideStyle
  }, props, {
    children: children
  }));
}

export { DisplayControllerAboutScrollDirection };
